"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validParams = ['requirePrefix'];
const isHex = (value, opts = {}) => {
    if (!(typeof value === 'string' || typeof value === 'number')) {
        return false;
    }
    if (value === '') {
        return false;
    }
    if (typeof value === 'number') {
        value = value.toString();
    }
    for (let key in opts) {
        if (!validParams.includes(key)) {
            throw new Error(`Unrecognized "${key}" option`);
        }
    }
    if (opts.requirePrefix && !value.startsWith('0x')) {
        return false;
    }
    // For our purposes `0x` is a valid hex string, as that is what is passed in to RPC Calls
    return /^(0[xX])?([0-9a-fA-F]|$)+$/.test(value);
};
exports.default = isHex;
